import { render, staticRenderFns } from "./InfoActivities.vue?vue&type=template&id=4b6a48bd"
import script from "./InfoActivities.vue?vue&type=script&lang=js"
export * from "./InfoActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports